export const GIFTING_CATEGORY_MENU_REGION = 'gifting-category-menu';

export const getGiftingCategoryMenuRegionProps = () => ({
  'data-region': GIFTING_CATEGORY_MENU_REGION,
});

export const getGiftingCategoryMenuPartProps = part =>
  part ? { 'data-part': part } : {};
